import { render, staticRenderFns } from "./DriversPeriodsAvailableOverviewSimple.vue?vue&type=template&id=379c0b95&scoped=true&"
import script from "./DriversPeriodsAvailableOverviewSimple.vue?vue&type=script&lang=js&"
export * from "./DriversPeriodsAvailableOverviewSimple.vue?vue&type=script&lang=js&"
import style0 from "./DriversPeriodsAvailableOverviewSimple.vue?vue&type=style&index=0&id=379c0b95&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379c0b95",
  null
  
)

export default component.exports